export default "__VITE_ASSET__BF9H5L85__"